module.exports = __webpack_public_path__ + "img/checklist-duotone.ffc70f34.svg";